import { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import type { Timestamp } from 'firebase/firestore';
import HomePage from './pages/HomePage';
import AuthModal from './components/AuthModal';
import { auth } from './config/firebase';
import {subscribeToUser} from './utils/firebaseService';
import './index.css';
import {
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import AdminPage from './pages/admin/AdminPage';
import AdminRoute
from './components/AdminRoute';
import AdminSecurityPage
from './pages/admin/AdminSecurityPage';
import AccountStatusGuard
from './guards/AccountStatusGuard';
import LegalConsentPage
from './pages/auth/LegalConsentPage';

function App() {

const [user, setUser] =useState<User | null>(null);
const [accountStatus, setAccountStatus] =useState<string | null>(null);
const [subscriptionExpiresAt,setSubscriptionExpiresAt] = useState<Timestamp | null>(null);
const [legalAcceptanceAccepted, setLegalAcceptanceAccepted] = useState(false);
const [loading, setLoading] =useState(true);

  useEffect(() => {

    let unsubscribeUser:(() => void) | null = null;
    const unsubscribe = onAuthStateChanged(

        auth,

        async (currentUser) => {

          setUser(currentUser);

          if (currentUser) {

            unsubscribeUser =
              subscribeToUser(

                currentUser.uid,

                (userData) => {

                  setAccountStatus(

                    userData?.accountStatus
                    || 'pending'

                  );

  setSubscriptionExpiresAt(
  userData?.subscriptionExpiresAt
  ?? null
);

  setLegalAcceptanceAccepted(
    Boolean(
      (userData as { legalAcceptance?: { accepted?: boolean } } | null)
        ?.legalAcceptance
        ?.accepted
    )
  );

                  setLoading(false);

                }

              );

          } else {

            unsubscribeUser?.();

            setAccountStatus(null);
            setLegalAcceptanceAccepted(false);

            setLoading(false);

          }

        }

      );

    return () => {

      unsubscribe();

      unsubscribeUser?.();

    };

  }, []);

  if (loading) {

    return (

      <div className="min-h-screen bg-dark-900 flex items-center justify-center text-white">

        Carregando...

      </div>

    );

  }

  if (window.location.pathname === '/dev/legal') {

    return (

      <Routes>

        <Route
          path="/dev/legal"
          element={
            <LegalConsentPage />
          }
        />

      </Routes>

    );

  }

  return (

    <>

      {!user && <AuthModal />}

      {user && (

        <AccountStatusGuard
  accountStatus={
    accountStatus
  }
  subscriptionExpiresAt={
    subscriptionExpiresAt
  }
  legalAcceptanceAccepted={
    legalAcceptanceAccepted
  }
>

          <Routes>

            <Route
              path="/"
              element={
                <HomePage user={user} />
              }
            />

            <Route
              path="/admin-security"
              element={
                <AdminSecurityPage />
              }
            />

            <Route
              path="/admin"
              element={
                <AdminRoute>

                  <AdminPage />

                </AdminRoute>
              }
            />

            <Route
              path="*"
              element={
                <Navigate to="/" />
              }
            />

          </Routes>

        </AccountStatusGuard>

      )}

    </>

  );

}

export default App;
